import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  Select,
  format_date,
  Pagination,
  GET,
  PUT,
  t,
  can,
} from "../../components/CustomComponent.js";
import { initials, avatarTone } from "../../components/people_option.js";
import { fileSize } from "../../components/partner_option.js";
import { COIN_ICON, coin } from "../../components/wallet_option.js";
import {
  TOPUP_STATUSES,
  STATUS_TRANSITIONS,
  REASON_REQUIRED_STATUSES,
  SORTS,
  EMPTY_SUMMARY,
  statusMeta,
  channelMeta,
  actionMeta,
  isImageSlip,
  baht,
} from "../../components/topup_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/crm.css";
import "../../assets/css/wallet.css";

/* ============================================================================
 * รายการเติมเหรียญ  (/ad/wallet/topups)
 *
 * คิวตรวจคำขอเติมเหรียญที่พาร์ตเนอร์ส่งเข้ามาพร้อมสลิป — งานคือ "เช็คเงินเข้า" :
 * เทียบยอดกับสลิปและรายการเดินบัญชีจริง แล้วอนุมัติให้เหรียญเข้ากระเป๋า
 * หรือไม่อนุมัติพร้อมเหตุผล
 *
 * หน้านี้ไม่มีปุ่มเพิ่มโดยตั้งใจ — คำขอเกิดจากพาร์ตเนอร์เท่านั้น (ปุ่มเติมเหรียญข้าง
 * ยอดเหรียญบนหัวหน้า) เหมือนที่ใบสมัครพาร์ตเนอร์เกิดจากหน้าเว็บสาธารณะเท่านั้น
 * ถ้าต้องเติมให้เองโดยไม่มีคำขอ ใช้ "ปรับยอด" ที่หน้าพาร์ตเนอร์ซึ่งบังคับให้ใส่เหตุผล
 *
 * เหรียญเข้ากระเป๋าตอน "อนุมัติ" เท่านั้น ไม่ใช่ตอนที่คำขอถูกส่ง
 *
 * ต่อกับ API แล้ว :
 *   GET  admin/wallet-topups              รายการ + ตัวกรอง (backend ตัดหน้าให้)
 *   GET  admin/wallet-topups/summary      การ์ดสรุป (ใช้ตัวกรองชุดเดียวกับตาราง)
 *   GET  admin/wallet-topups/:uid         รายละเอียดใบเดียว
 *   PUT  admin/wallet-topups/:uid/review  ตัดสิน (wallet-topups.approve — สิทธิ์คนละข้อ)
 * ========================================================================== */

const EMPTY_FILTER = { search: "", status: "" };

// จำนวนคำขอต่อหน้า — เท่ากับหน้ารายการอื่นของหลังบ้าน (ลูกค้า/นัดหมาย/พาร์ตเนอร์)
// ส่งเป็น page_size ไปให้ backend ตัดหน้าให้ ไม่ได้ดึงมาทั้งก้อนแล้วหั่นที่หน้าจอ
const PAGE_SIZE = 10;

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

const dateText = (value) => (value ? format_date(value, "dd mmm yyyy", locale()) : "-");
const timeText = (value) => (value ? format_date(value, "hh:mm", locale()) : "");
const dateTimeText = (value) => (value ? format_date(value, "dd mmm yyyy hh:mm", locale()) : "-");

const num = (value) => Number(value || 0).toLocaleString("en-US");

export default class WalletTopups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      // จำนวนคำขอทั้งหมดที่เข้าเงื่อนไข (backend เป็นคนนับ) — ใช้คิดจำนวนหน้า
      count: 0,
      summary: { ...EMPTY_SUMMARY },

      /* filter = ค่าที่กำลังกรอกอยู่ในแถบค้นหา, applied = ค่าที่กรองรายการอยู่จริง
         แยกกันเพราะการกรองรอปุ่ม "ค้นหา" ซึ่งคือการยิง API ใหม่ —
         ถ้ากรองสดทุกตัวอักษรจะกลายเป็นยิงคำขอทุกครั้งที่พิมพ์ */
      filter: { ...EMPTY_FILTER },
      applied: { ...EMPTY_FILTER },

      // การเรียงลำดับส่งให้ backend เหมือนตัวกรองอื่น แต่ไม่ต้องรอปุ่มค้นหา
      // (เป็นการจัดของชุดเดิม ไม่ใช่การเปลี่ยนว่าจะเอาของชุดไหน)
      sort: "created_desc",

      page: 1,

      modal_view: false,
      detail: null,
      /* กล่องเดียวใช้สองโหมด : ดูอย่างเดียว กับ ตรวจสอบ (มีส่วนตัดสินใจ)
         แยกเป็นสองกล่องคนละใบจะได้โครงรายละเอียดที่ต้องดูแลซ้ำกันสองที่ */
      review_mode: false,
      review: { to: "", reason: "" },
      zoom: null,
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* ------------------------------------------------------------ ดึงข้อมูล */

  /** พารามิเตอร์ที่ส่งขึ้น API — ตัดคีย์ที่ว่างทิ้งเพื่อไม่ให้ backend เห็นเป็นตัวกรอง */
  query = (page, filter, sort) => {
    const params = {
      page,
      page_size: PAGE_SIZE,
      sort,
      data_search: filter.search,
      status: filter.status,
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
    );
  };

  Get = async (page = 1, filter = this.state.filter, sort = this.state.sort) => {
    loading(true);
    /* การ์ดสรุปใช้ตัวกรองชุดเดียวกับตาราง (ยกเว้นสถานะ ซึ่ง backend ตัดออกให้เอง)
       ยิงคู่กันเสมอ — ตัดสินใบหนึ่งแล้วตัวเลขบนการ์ดต้องขยับตาม ไม่ใช่ค้างค่าเดิม
       จนกว่าจะรีเฟรชหน้า */
    const [result, summary] = await Promise.all([
      GET("admin/wallet-topups", this.query(page, filter, sort)),
      GET("admin/wallet-topups/summary", this.query(0, filter, sort)),
    ]);
    loading(false);

    if (!result?.status) return;

    const rows = result.data || [];

    // ตัดสินใบสุดท้ายของหน้าแล้วหน้านั้นว่าง — ถอยไปหน้าก่อนหน้าให้อัตโนมัติ
    if (!rows.length && page > 1) return this.Get(page - 1, filter, sort);

    this.setState({
      rows,
      count: result.pagination?.count || 0,
      page,
      applied: { ...filter },
      sort,
      summary: summary?.status ? { ...EMPTY_SUMMARY, ...summary.data } : this.state.summary,
    });
  };

  /* -------------------------------------------------------------- ตัวกรอง */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  /* เปลี่ยนเงื่อนไขแล้วต้องกลับหน้า 1 เสมอ — ไม่งั้นค้างอยู่หน้า 3 ของผลลัพธ์เก่า
     แล้วผลลัพธ์ใหม่มีหน้าเดียว จะเจอตารางว่างทั้งที่กรองเจอของ */
  Search = () => this.Get(1, this.state.filter, this.state.sort);

  Reset = () => {
    const filter = { ...EMPTY_FILTER };
    this.setState({ filter }, () => this.Get(1, filter, this.state.sort));
  };

  ChangeSort = (sort) => this.Get(1, this.state.applied, sort);

  GoPage = (page) => {
    this.Get(page, this.state.applied, this.state.sort);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* --------------------------------------------------------------- ตรวจสอบ */

  /* ยิงขอรายละเอียดใหม่เสมอแทนการใช้แถวในตาราง — ใบนี้อาจถูกแอดมินคนอื่นตัดสินไปแล้ว
     ตั้งแต่ตอนที่ตารางโหลดมา และการกดอนุมัติซ้ำใบเดิมคือเหรียญเข้ากระเป๋าสองรอบ
     (backend ล็อกแถวกันไว้อีกชั้น แต่ผู้ใช้ควรเห็นสถานะจริงก่อนจะกด ไม่ใช่กดแล้ว
     เจอข้อความปฏิเสธโดยไม่รู้ว่าเกิดอะไรขึ้น) */
  loadDetail = async (uid) => {
    loading(true);
    const result = await GET(`admin/wallet-topups/${uid}`);
    loading(false);

    return result?.status ? result.data : null;
  };

  Open = async (item, review_mode) => {
    const detail = await this.loadDetail(item.uid);
    if (!detail) return;

    this.setState({ modal_view: true, detail, review_mode, review: { to: "", reason: "" }, zoom: null });
  };

  /* ดูอย่างเดียว — ใช้กับทุกสถานะ รวมใบที่ตัดสินไปแล้ว */
  OpenView = (item) => this.Open(item, false);

  /* ตรวจสอบ — เปิดส่วนตัดสินใจด้วย เฉพาะใบที่ยังรอตรวจสอบและคนที่มีสิทธิ์อนุมัติ */
  OpenReview = (item) => this.Open(item, true);

  CloseView = () =>
    this.setState({ modal_view: false, detail: null, review_mode: false, review: { to: "", reason: "" }, zoom: null });

  /* ตรวจสอบได้ไหม — ใบที่ตัดสินไปแล้วไม่มีทางออก (STATUS_TRANSITIONS ว่าง) */
  canReview = (item) => can("wallet-topups.approve") && (STATUS_TRANSITIONS[item.status] || []).length > 0;

  setReview = (patch) => this.setState((prev) => ({ review: { ...prev.review, ...patch } }));

  Review = async (to) => {
    const { detail, review } = this.state;
    const meta = actionMeta(to);

    if (REASON_REQUIRED_STATUSES.includes(to) && !review.reason.trim())
      return alert("", "warning", t("warning"), t("topup_reason_required"));

    /* ผลของการอนุมัติกระทบยอดเหรียญจริง จึงถามยืนยันแยกจากการกดเลือกสถานะ */
    const confirmText = to === "approved" ? t("topup_approve_confirm") : t("confirm_submission");
    if (!(await alert("", "info", t(meta.label), confirmText, t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT(`admin/wallet-topups/${detail.uid}/review`, {
      status: to,
      ...(REASON_REQUIRED_STATUSES.includes(to) ? { reason: review.reason.trim() } : {}),
    });
    loading(false);

    if (!result?.status) return;

    this.setState({ modal_view: false, detail: null, review_mode: false, review: { to: "", reason: "" }, zoom: null });

    // โหลดหน้าเดิมใหม่ — ทั้งสถานะในตารางและตัวเลขบนการ์ดสรุปต้องขยับพร้อมกัน
    await this.Get(this.state.page, this.state.applied, this.state.sort);

    alert("", "success", t("success"), t("topup_review_done"));
  };

  /* ======================================================= render : การ์ดสรุป */
  renderSummary = () => {
    const s = this.state.summary;

    /* สี่ใบพอ — "ค้างในคิว" ซ้ำกับ "รอตรวจสอบ" ตั้งแต่ตัดสถานะกลางออกไปแล้ว */
    const cards = [
      { label: "topup_kpi_pending", value: s.status.pending, hint: "topup_kpi_pending_hint", icon: "\uf017", color: "#b45309", tint: "#fef3c7" },
      { label: "topup_kpi_approved", value: s.status.approved, hint: "topup_kpi_approved_hint", icon: "\uf058", color: "#15803d", tint: "#dcfce7" },
      {
        label: "topup_kpi_amount",
        value: s.approved_amount,
        hint: t("topup_kpi_amount_hint"),
        raw_hint: true,
        money: true,
        icon: "\uf0d6",
        color: "#4d7c0f",
        tint: "#eaf9d2",
      },
      { label: "topup_kpi_rejected", value: s.status.rejected, hint: "topup_kpi_rejected_hint", icon: "\uf057", color: "#b91c1c", tint: "#fee2e2" },
    ];

    return (
      <div className="row g-3 mb-3">
        {cards.map((card, i) => (
          <div className="col-xl-3 col-sm-6" key={i}>
            <div className="crm-stat prop-in">
              <span className="crm-stat__edge" style={{ backgroundColor: card.color }} />
              <span className="crm-stat__icon icon" style={{ backgroundColor: card.tint, color: card.color }}>
                {card.icon}
              </span>
              <div className="min-w-0">
                <div className="crm-stat__label text-truncate">{t(card.label)}</div>
                <div className="crm-stat__value">{card.money ? baht(card.value) : num(card.value)}</div>
                <div className="crm-stat__hint text-truncate">{card.raw_hint ? card.hint : t(card.hint)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  /* ==================================================== render : ตัวกรอง */
  /* กรองด้วยสถานะเป็นหลัก — คำถามแรกของคนเปิดหน้านี้คือ "มีอะไรรอตรวจอยู่บ้าง"
     ไม่ใช่ "โอนมาทางไหน" ส่วนช่องทางอ่านได้จากตารางอยู่แล้วและมีให้เลือกแค่สองแบบ */
  renderToolbar = () => {
    const { filter, applied, sort } = this.state;
    const dirty = JSON.stringify(filter) !== JSON.stringify(EMPTY_FILTER);
    const filtering = JSON.stringify(applied) !== JSON.stringify(EMPTY_FILTER);

    return (
      <div className="prop-card prop-in mb-3">
        <div className="p-3 d-flex flex-wrap align-items-center gap-2">
          <div className="position-relative flex-grow-1" style={{ minWidth: "220px", maxWidth: "360px" }}>
            <span className="icon prop-field-icon">{"\uf002"}</span>
            <input
              type="text"
              className="prop-field prop-field--icon"
              placeholder={t("topup_search_placeholder")}
              value={filter.search}
              onChange={(e) => this.setFilter({ search: e.target.value })}
              /* กด Enter ในช่องค้นหาต้องได้ผลเหมือนกดปุ่ม ไม่ใช่เงียบไป */
              onKeyDown={(e) => e.key === "Enter" && this.Search()}
            />
          </div>

          <div style={{ minWidth: "190px" }}>
            <Select
              className="prop-field prop-select"
              placeholder={t("topup_status_all")}
              value={filter.status}
              options={TOPUP_STATUSES.map((item) => ({ value: item.value, label: t(item.label) }))}
              onChange={(value) => this.setFilter({ status: value || "" })}
            />
          </div>

          <button type="button" className="prop-btn" onClick={this.Search}>
            <span className="icon text-12">{"\uf002"}</span>
            {t("search")}
          </button>

          {/* รีเซ็ตอยู่คู่กับค้นหาเสมอ ไม่ซ่อนตามเงื่อนไข — ปุ่มที่โผล่มาแล้วหายไปทำให้
              ปุ่มอื่นในแถวขยับตำแหน่ง และคนที่กรองค้างไว้จะหาทางล้างไม่เจอ
              ไม่มีอะไรให้ล้างก็แค่กดแล้วไม่เกิดอะไร ซึ่งไม่เสียหาย */}
          <button
            type="button"
            className="prop-btn prop-btn--ghost"
            disabled={!dirty && !filtering}
            onClick={this.Reset}
          >
            <span className="icon text-12">{"\uf0e2"}</span>
            {t("reset")}
          </button>

          <div className="ms-auto d-flex align-items-center gap-2">
            <span className="text-secondary text-12">{t("sort_by")}</span>
            <div style={{ minWidth: "180px" }}>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("sort_by")}
                value={sort}
                options={SORTS.map((item) => ({ value: item.value, label: t(item.label) }))}
                onChange={(value) => value && this.ChangeSort(value)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ==================================================== render : ตาราง */
  badge = (status) => {
    const meta = statusMeta(status);
    return (
      <span className="tpu-pill" style={{ background: meta.tint, color: meta.tone }}>
        <span className="icon text-12">{meta.icon}</span>
        {t(meta.label)}
      </span>
    );
  };

  /* ช่องผู้ตรวจสอบ — ใช้คำเดียวกับกล่องรายละเอียด (t("topup_reviewer")) เพราะช่องนี้
     ขึ้นชื่อคนตัดสินของใบที่ "ไม่อนุมัติ" ด้วย หัวคอลัมน์ว่า "ผู้อนุมัติ" จะอ่านผิด
     ในแถวที่เขาเป็นคนปฏิเสธ ส่วนผลออกมาทางไหนดูได้จากช่องสถานะที่อยู่ติดกัน

     ใบที่ยังไม่มีใครตัดสินใส่ขีดไว้แทนที่จะเว้นว่าง เพื่อให้อ่านออกว่า "ยังไม่มี"
     ไม่ใช่ "ข้อมูลหาย" */
  renderReviewer = (item) => {
    if (!item.reviewer?.full_name) return <span className="ppl-sub">-</span>;

    return (
      <div className="d-flex align-items-center gap-2">
        <div className="ppl-avatar ppl-avatar--sm" style={{ background: avatarTone(item.reviewer.full_name) }}>
          {initials(item.reviewer.full_name)}
        </div>
        <div className="min-w-0">
          <div className="ppl-name text-truncate">{item.reviewer.full_name}</div>
          <div className="ppl-sub text-truncate">{dateText(item.reviewed_at)}</div>
        </div>
      </div>
    );
  };

  renderTable = (rows) => {
    return (
      <div className="prop-card prop-in">
        <div className="table-responsive" style={{ borderRadius: "18px" }}>
          <table className="ppl-table" style={{ minWidth: "1380px" }}>
            <thead>
              <tr>
                <th style={{ width: "168px" }}>{t("topup_col_code")}</th>
                <th style={{ width: "244px" }}>{t("partners")}</th>
                <th style={{ width: "168px" }}>{t("topup_col_amount")}</th>
                <th style={{ width: "168px" }}>{t("topup_channel")}</th>
                <th style={{ width: "150px" }}>{t("topup_transferred_at")}</th>
                <th style={{ width: "160px" }}>{t("status")}</th>
                <th style={{ width: "200px" }}>{t("topup_reviewer")}</th>
                <th className="text-center" style={{ width: "116px" }}>{t("actions")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((item) => (
                <tr key={item.uid}>
                  {/* เลขที่คำขอ + เวลาที่ส่ง */}
                  <td>
                    <div className="ppl-name text-truncate">{item.code}</div>
                    <div className="ppl-sub">{dateTimeText(item.created_at)}</div>
                  </td>

                  <td>
                    <div className="d-flex align-items-center gap-3">
                      <div className="ppl-avatar" style={{ background: avatarTone(item.partner?.full_name) }}>
                        {initials(item.partner?.full_name)}
                      </div>
                      <div className="min-w-0">
                        <div className="ppl-name text-truncate">{item.partner?.full_name}</div>
                        <div className="ppl-sub text-truncate">{item.partner?.code}</div>
                      </div>
                    </div>
                  </td>

                  {/* ยอดเงิน -> เหรียญที่จะได้ อ่านคู่กันเสมอ */}
                  <td>
                    <div className="tpu-money">
                      <b>{baht(item.amount)}</b> {t("baht")}
                    </div>
                    <div className="ppl-sub d-flex align-items-center gap-1">
                      <span className="icon text-10">{COIN_ICON}</span>
                      {coin(item.coin)} {t("wallet_unit_coin")}
                    </div>
                  </td>

                  <td>
                    <div className="text-truncate">{t(channelMeta(item.channel).label)}</div>
                    {/* สลิปเปิดดูได้จากตารางเลย ไม่ต้องเข้ากล่องตรวจสอบก่อน */}
                    <button type="button" className="tpu-sliplink" onClick={() => this.OpenView(item)}>
                      <span className="icon text-10">{"\uf03e"}</span>
                      {t("topup_slip")}
                    </button>
                  </td>

                  <td>
                    <div className="text-truncate">{dateText(item.transferred_at)}</div>
                    <div className="ppl-sub">{timeText(item.transferred_at)}</div>
                  </td>

                  <td>{this.badge(item.status)}</td>

                  <td>{this.renderReviewer(item)}</td>

                  {/* ดูได้ทุกใบ ส่วนตรวจสอบมีเฉพาะใบที่ยังรอตรวจสอบ — ใบที่ตัดสินไปแล้ว
                      ย้อนกลับไม่ได้ ปุ่มที่กดแล้วไม่เกิดอะไรมีแต่ทำให้เข้าใจผิด
                      ปุ่มเป็นไอคอนล้วนชุดเดียวกับหน้าพาร์ตเนอร์ ชื่อปุ่มอยู่ใน tooltip */}
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        type="button"
                        className="prop-iconbtn prop-iconbtn--dark icon"
                        title={t("view_detail")}
                        onClick={() => this.OpenView(item)}
                      >
                        {"\uf06e"}
                      </button>

                      {this.canReview(item) && (
                        <button
                          type="button"
                          className="prop-iconbtn icon"
                          title={t("check")}
                          onClick={() => this.OpenReview(item)}
                        >
                          {"\uf00c"}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}

              {!rows.length && (
                <tr>
                  <td colSpan={8}>
                    <div className="tpu-empty">
                      <span className="icon">{"\uf002"}</span>
                      {t("topup_no_result")}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* ============================================ render : ตาราง + แบ่งหน้า */
  /* backend ตัดหน้ามาให้แล้ว หน้าจอมีหน้าที่แค่วาดแถวที่ได้มา และคิดจำนวนหน้า
     จาก count ที่ตอบกลับมาพร้อมกัน (ดู query() / Get()) */
  renderList = () => {
    const { rows, count, page } = this.state;

    const pages = Math.max(1, Math.ceil(count / PAGE_SIZE));

    const from = count ? (page - 1) * PAGE_SIZE + 1 : 0;
    // แถวสุดท้ายของหน้านี้คิดจากจำนวนแถวที่ได้จริง ไม่ใช่จากขนาดหน้า —
    // หน้าสุดท้ายมักไม่เต็มหน้า
    const to = (page - 1) * PAGE_SIZE + rows.length;

    return (
      <>
        {this.renderTable(rows)}

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 text-secondary text-12">
          <div>
            {t("showing")} {num(from)}-{num(to)} {t("of")} {num(count)} {t("topup_unit")}
          </div>
          {/* หน้าเดียวก็ไม่ต้องมีตัวเลขให้กด — แถบที่กดแล้วไม่มีอะไรเปลี่ยนคือของเกะกะ */}
          {pages > 1 && (
            <Pagination
              className="mb-0"
              page={page}
              count={pages}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, next) => this.GoPage(next)}
            />
          )}
        </div>
      </>
    );
  };

  /* ============================================ render : กล่องตรวจสอบ */
  detailRow = (label, value) => (
    <div className="tpu-row">
      <span className="tpu-row__label">{label}</span>
      <span className="tpu-row__value">{value || "-"}</span>
    </div>
  );

  renderDetailModal = () => {
    const { modal_view, detail, review_mode, review, zoom } = this.state;
    if (!modal_view || !detail) return null;

    // โหมดดูอย่างเดียวไม่มีส่วนตัดสินใจ ถึงจะเปิดจากบัญชีที่มีสิทธิ์อนุมัติก็ตาม
    const choices = review_mode && this.canReview(detail) ? STATUS_TRANSITIONS[detail.status] || [] : [];
    const needReason = REASON_REQUIRED_STATUSES.includes(review.to);
    const meta = review.to ? actionMeta(review.to) : null;
    const ready = !!review.to && (!needReason || !!review.reason.trim());
    const slip = detail.slip || {};

    return (
      /* กล่องแคบคอลัมน์เดียว (ดู .tpu-dialog) — ของที่ต้องอ่านจริง ๆ มีไม่กี่บรรทัด
         กล่องกว้างเต็มจอทำให้ยอดเงินกับสลิปอยู่คนละฝั่งตา ต้องกวาดซ้ายขวาเทียบเอง
         เรียงลงมาแนวตั้งแทน : สลิป -> ยอด -> ที่มา -> การตัดสิน อ่านรวดเดียวจบ */
      <Modal
        show={modal_view}
        onHide={this.CloseView}
        centered
        dialogClassName="tpu-dialog"
        contentClassName="tpu-modal"
      >
        <div className="tpu-hero">
          <span className="tpu-hero__coin icon">{COIN_ICON}</span>
          <div className="min-w-0 flex-grow-1">
            <div className="tpu-hero__title">{detail.code}</div>
            <div className="tpu-hero__balance">
              {detail.partner?.full_name} · {detail.partner?.code}
            </div>
          </div>
          {/* ไม่มีปุ่มปิดของตัวเอง — Modal ของโปรเจกต์วาดปุ่ม X มุมบนขวาให้อยู่แล้ว
              ตอนที่ส่ง onHide เข้าไป (ดู CustomComponent.Modal) ใส่เองจะทับกันสองปุ่ม
              เว้นที่ด้านขวาไว้ให้ปุ่มนั้นด้วย padding ของ .tpu-hero */}
          {this.badge(detail.status)}
        </div>

        <Modal.Body className="tpu-body">
          <div className="tpu-stack">
            {/* สลิป — ย่อเป็นรูปตัวอย่างเตี้ย ๆ พอให้เห็นว่าแนบอะไรมาและอ่านยอดคร่าว ๆ
                การตรวจจริงคือกดขยายเต็มกล่อง (ดู .tpu-zoom ท้ายไฟล์) ซึ่งชัดกว่าการ
                ปล่อยให้รูปสูงครึ่งกล่องอยู่ตลอดเวลาแล้วดันข้อมูลที่เหลือตกไปใต้จอ */}
            <div className="tpu-slipbox">
              {slip.file_path && isImageSlip(slip) ? (
                <button type="button" className="tpu-slipbox__img" onClick={() => this.setState({ zoom: slip })}>
                  <img src={slip.file_path} alt="" />
                  <span className="tpu-slipbox__zoom icon">{"\uf00e"}</span>
                </button>
              ) : (
                /* ไม่ใช่รูป = สลิป PDF (แอปธนาคารบางเจ้าให้ดาวน์โหลดเป็น PDF) หรือไม่มีสลิป
                   PDF ต้องกดเปิดได้จริง ไม่ใช่การ์ดชื่อไฟล์ที่กดแล้วไม่เกิดอะไร —
                   คนเปิดหน้านี้มาเพื่อ "ดูสลิป" ถ้าเปิดไม่ได้ก็ตรวจไม่ได้ทั้งใบ
                   เปิดแท็บใหม่แทนการฝัง viewer : เบราว์เซอร์แสดง PDF ได้เองอยู่แล้ว */
                <a
                  className={`tpu-slipbox__none${slip.file_path ? " tpu-slipbox__none--link" : ""}`}
                  href={slip.file_path || undefined}
                  target={slip.file_path ? "_blank" : undefined}
                  rel={slip.file_path ? "noreferrer" : undefined}
                >
                  <span className="icon">{slip.file_path ? "\uf1c1" : "\uf15c"}</span>
                  <div className="tpu-slipbox__name">{slip.file_name || t("topup_no_slip")}</div>
                  <div className="tpu-slipbox__size">{slip.file_size ? fileSize(slip.file_size) : ""}</div>
                </a>
              )}
            </div>

            {/* ยอดเงิน -> เหรียญ คือตัวเลขคู่เดียวที่ต้องเทียบกับสลิป ยกออกมาเป็นแถบของตัวเอง
                เหนือรายละเอียดที่เหลือ ไม่ให้ไปปนเป็นแถวเล็ก ๆ แถวหนึ่งในสิบแถว */}
            <div className="tpu-amount">
              <div className="tpu-amount__side">
                <div className="tpu-amount__label">{t("topup_amount")}</div>
                <div className="tpu-amount__value">
                  {baht(detail.amount)} <span className="tpu-amount__unit">{t("baht")}</span>
                </div>
              </div>
              <span className="tpu-amount__arrow icon">{"\uf061"}</span>
              <div className="tpu-amount__side tpu-amount__side--coin">
                <div className="tpu-amount__label">{t("topup_will_get")}</div>
                <div className="tpu-amount__value">
                  <span className="icon">{COIN_ICON}</span> {coin(detail.coin)}{" "}
                  <span className="tpu-amount__unit">{t("wallet_unit_coin")}</span>
                </div>
              </div>
            </div>

            <div className="tpu-sec">
              <div className="tpu-sec__head">
                <span className="icon">{"\uf05a"}</span>
                {t("topup_section_detail")}
              </div>
              {this.detailRow(t("topup_channel"), t(channelMeta(detail.channel).label))}
              {this.detailRow(t("topup_transferred_at"), dateTimeText(detail.transferred_at))}
              {this.detailRow(t("topup_submitted_at"), dateTimeText(detail.created_at))}
              {this.detailRow(t("note"), detail.note)}
            </div>

            {(!!detail.reviewer || !!detail.reason) && (
              <div className="tpu-sec">
                <div className="tpu-sec__head">
                  <span className="icon">{"\uf1da"}</span>
                  {t("topup_section_history")}
                </div>
                {this.detailRow(t("topup_reviewer"), detail.reviewer?.full_name)}
                {this.detailRow(t("topup_reviewed_at"), detail.reviewed_at ? dateTimeText(detail.reviewed_at) : "")}
                {this.detailRow(t("topup_reason"), detail.reason)}
              </div>
            )}

            {/* การตัดสิน — เห็นเฉพาะคนที่มีสิทธิ์อนุมัติ และเฉพาะใบที่ยังไม่ถึงปลายทาง */}
            {!!choices.length && (
              <div className="tpu-sec tpu-sec--decide">
                <div className="tpu-sec__head">
                  <span className="icon">{"\uf0e3"}</span>
                  {t("topup_decision_title")}
                </div>

                <div className="tpu-picks">
                  {choices.map((to) => {
                    const pick = actionMeta(to);
                    const tone = statusMeta(to);
                    const danger = REASON_REQUIRED_STATUSES.includes(to);
                    const on = review.to === to;

                    return (
                      <button
                        key={to}
                        type="button"
                        aria-pressed={on}
                        className={`tpu-pick${on ? " is-active" : ""}${danger ? " tpu-pick--danger" : ""}`}
                        onClick={() => this.setReview({ to, reason: "" })}
                      >
                        <span className="tpu-pick__icon icon" style={{ background: tone.tint, color: tone.tone }}>
                          {pick.icon}
                        </span>
                        <span className="tpu-pick__body">
                          <span className="tpu-pick__label">{t(pick.label)}</span>
                          <span className="tpu-pick__desc">{t(`topup_pick_${to}`)}</span>
                        </span>
                        <span className="tpu-pick__mark icon">{"\uf058"}</span>
                      </button>
                    );
                  })}
                </div>

                {/* เหตุผลบังคับเฉพาะ "ไม่อนุมัติ" — พาร์ตเนอร์เห็นข้อความนี้แล้วแก้ก่อนส่งใหม่ */}
                {needReason && (
                  <div className="tpu-reason mt-3">
                    <div className="tpu-reason__head">
                      <span className="tpu-reason__title">{t("topup_reason")}</span>
                      <span className="tpu-reason__count">{(review.reason || "").length}/1000</span>
                    </div>
                    <textarea
                      className="prop-field"
                      rows={3}
                      maxLength={1000}
                      autoFocus
                      placeholder={t("topup_reason_placeholder")}
                      value={review.reason}
                      onChange={(e) => this.setReview({ reason: e.target.value })}
                    />
                  </div>
                )}

                {review.to === "approved" && (
                  <div className="ppl-note mt-3">
                    <span className="icon">{"\uf05a"}</span>
                    <div>
                      {t("topup_approve_hint")} <b>{coin(detail.coin)}</b> {t("wallet_unit_coin")}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* สลิปที่กดขยาย — ทับอยู่ในกล่องเดิม ไม่เปิดกล่องซ้อนกล่อง */}
          {!!zoom && (
            <button type="button" className="tpu-zoom" onClick={() => this.setState({ zoom: null })}>
              <img src={zoom.file_path} alt="" />
            </button>
          )}
        </Modal.Body>

        <div className="tpu-foot">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseView}>
            {t("close")}
          </button>

          {!!choices.length && (
            <button type="button" className="prop-btn" disabled={!ready} onClick={() => this.Review(review.to)}>
              {!!meta && <span className="icon text-12">{meta.icon}</span>}
              {meta ? t(meta.label) : t("topup_decision_pick")}
            </button>
          )}
        </div>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("topup_review")}</h3>
              <div className="text-secondary text-14">{t("topup_page_desc")}</div>
            </div>
          </div>

          {this.renderSummary()}
          {this.renderToolbar()}
          {this.renderList()}
          {this.renderDetailModal()}
        </div>
      </div>
    );
  }
}
